import {useContext, useEffect, useState, useCallback, useRef} from 'react';
import {Button, Dialog, DialogContent, DialogTitle, DialogActions, CircularProgress, Container, Grid, TextField} from '@mui/material';
import {useParams, useHistory} from 'react-router-dom';
import {Controller, useForm} from 'react-hook-form';
import {DocumentService} from '../../../services';
import ValidationError from "../../shared/ValidationError";
import {NotificationContext} from "../../../components/NotificationContext";
import Prompt from "../../../customUtil/Prompt";
import { CurrentUserContext } from '../../../components/CurrentUserContext';


const DocumentForm = () => {
    const methods = useForm();
    const [data, setData] = useState({});
    const [isReady, setIsReady] = useState(false);
    const {showMessage, showError} = useContext(NotificationContext)
    const {id} = useParams();
    const history = useHistory();
    const [block, setBlock] = useState(false);  
    const refSubmitButtom = useRef();
    const [open, setOpen] = useState(false);
    const [openConfirmation, setOpenConfirmation] = useState(false);
    const [openInfo, setOpenInfo] = useState(false);
    const {handleSubmit, control, errors} = methods;
    const [showProgress, setShowProgress] = useState(false);
    const {rights} = useContext(CurrentUserContext);

    const [triggerExit, setTriggerExit] = useState({
        onOk: false,
        path: ""
      });
      const [isVisibleDialog, setVisibleDialog] = useState(false);

    const handleGoToIntendedPage = useCallback(
        (location) => history.push(location),
        [history]
      );
      
      const handleClose = () => {
        setOpen(false);
        setOpenConfirmation(false);
        setOpenInfo(false);
    }

    const removeDocument = () => {
        setShowProgress(true);
        DocumentService.delete(data.id).then((response) => {                
                showMessage('Successfully Deleted');
                history.push("/templates/documents");   
                setShowProgress(false);                                
            }).catch((response) => {
            handleClose();
            setOpenInfo(true);
            setShowProgress(false);                                

        });
    }

      useEffect(() => {
       
        const unblock = history.block((location) => {
          if (location.pathname !== `/gas/account-statements/${id}`) {
            if(block){
                setVisibleDialog(true);   
                setTriggerExit({...triggerExit, path: location.pathname});
            }else{
                setVisibleDialog(false);   
                setTriggerExit({onOk: true, path: location.pathname});
            }
                           
              }
         
          if (triggerExit.onOk) {
            return true;
          }
          return false;
        });
        if (triggerExit.onOk) {
            handleGoToIntendedPage(triggerExit.path);
          }
        return () => {
          unblock();
        };
      }, [history, triggerExit.onOk, triggerExit.path, block]);
   

    useEffect(() => {
        if (id !== "new") {
            DocumentService.getById(id).then((response) => {
                setData(response.data);
                setIsReady(true);
            });
        } else {
            setData({});
            setIsReady(true);
        }
    }, [id]);

    const onSubmit = d => {
        setBlock(false);
        setVisibleDialog(false);
        if (data.id) {
            DocumentService.update({...data, ...d})
                .then((response) => {
                    showMessage('Document updated.')
                });
        } else {
            DocumentService.create({...data, ...d})
                .then((response) => {
                    setData(response.data);
                    showMessage('Document Created.');
                }).catch((response) => {
                showError(response.message)
            });
        }
        setTimeout(() => {
            setIsReady(true);
            history.push('/templates/documents')
        }, 100)   
    };

    if (!isReady) {
        return (
            <CircularProgress/>
        );
    }
    
    const triggerSubmit = () => {
        refSubmitButtom?.current?.click();
      };     
   
      const onSave = (event) => {   
          triggerSubmit();
          setBlock(false);
          setVisibleDialog(false);
      }
  
      const checkModified = (event) => {
          if(event.type ===  "change"){
              setBlock(true);
                 }
              }

    return (
        <Container>
            <header>
                <h1>Document</h1>

            </header>
            <form style={{textAlign: 'left'}} onSubmit={handleSubmit(onSubmit)} onChange={event => {checkModified(event)}}>
            <Prompt
               visible={isVisibleDialog}
               onClose={() => setVisibleDialog(false)}
               onOk={() => {
               setTriggerExit({...triggerExit, onOk: true});
               setVisibleDialog(false);
               setBlock(false);
            }}
               onSave={onSave}
            />
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <Controller
                            name="title"
                            control={control}
                            as={TextField}
                            fullWidth
                            label="Title"
                            color="primary"
                            variant="outlined"
                            rules={{required: 'Title is required.'}}
                            defaultValue={data.title}
                            render={({onChange, value}) => <TextField
                                autoComplete="title"
                                value={value}
                            />}
                        />
                        <ValidationError error={errors.title}/>
                    </Grid>
                    <Grid item xs={10}>
                            <Button variant="contained" color="primary" type="submit">Submit</Button>
                        </Grid>
                        {(rights.includes("ROLE_SI_ADMIN") && id !== 'new') &&    
                        <Grid item xs={2}>
                            <Button variant="contained" color="danger" onClick={() => setOpenConfirmation(true)}>Remove statement</Button>
                        </Grid>
                     }
                </Grid>
                <button hidden={true} ref={refSubmitButtom} type={"submit"} />
            </form>
            <Dialog open={openConfirmation} onClose={handleClose} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">Confirm Delete</DialogTitle>
                    <DialogContent>                      
                          Are you sure you want to delete this document?                                           
                    </DialogContent>
                    <DialogActions>
                        {showProgress &&  <CircularProgress style={{width: "12px", height: "10px"}}/>}                       
                    <Button onClick={removeDocument} color="primary" disabled={showProgress}>
                            yes
                        </Button>
                        <Button onClick={handleClose} color="primary">
                            No
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={openInfo} onClose={handleClose} aria-labelledby="form-dialog-title">                   
                    <DialogContent>                       
                          This document can not be deleted because it is already in use.                                             
                    </DialogContent>
                    <DialogActions>                    
                        <Button onClick={handleClose} color="primary">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog> 
        </Container>
    );
};

export default DocumentForm;
